/**
* @desc the ngTransferRecap provides support for displaying information of the added Transfer in Purchase 3 and Purchase 4
*/
webClient.directive('ngTransferRecap', ['$window', 'templateService', '$timeout',
    function ($window, templateService, $timeout) {
        var directive = {};
        directive.restrict = 'EA';
        directive.scope = {
            purchaseid: "=",
            transferid: "=",
            isTransferInfoFromParent: "=", 
            transferinfo: "=", // it contains the transfer infos if we need have transfer info in the parent
            ontoggle: "&"
        };
        directive.link = function ($scope, $element) {
            templateService.compile($scope, $element, 'tpl/_TransferRecapTPL.html');

            $scope.isTransferRecapLoading = true;
            $scope.displayTransferRecap = true;

            $scope.getTemplateUrl = $window.getTemplateUrl;
            if ($scope.isTransferInfoFromParent) {
                if ($scope.transferinfo) {
                    initransferInfo($scope.transferinfo);
                }
            } else {
                var getTransferRQ = {
                    purchaseId: $scope.purchaseid,
                    transferId: $scope.transferid,
                    partnerId: window.site.partnerId,
                    requestId: window.$scope.bkgData.request.requestId
                };
                window.Typescript.Transfer.Services.TransferService.getTransfer(getTransferRQ).then(function (res) {
                    console.log(res);
                    if (res.data && res.data.status === 0) {
                        initransferInfo(res.data.transfer);
                    }
                    else {
                        $timeout(() => {
                            $scope.displayTransferRecap = false;
                        }, 0);
                    }
                }).catch(error => {
                    console.error('Erreur getTransfer :', error);
                    $timeout(() => {
                        $scope.displayTransferRecap = false;
                    }, 0);
                })
            }
            function initransferInfo(transferInfo) {
                $timeout(() => {
                    $scope.transferInfo = transferInfo;
                    $scope.transferPictoUrl = 'images/products/';
                    const transferTypeLowCase = $scope.transferInfo.transferType.toLowerCase();
                    const vehicleCategoryLowCase = $scope.transferInfo.vehicle.category.toLowerCase();
                    const vehicleTypeLowCase = $scope.transferInfo?.vehicle?.type?.toLowerCase();
                    if (vehicleTypeLowCase == "boat" && vehicleCategoryLowCase == "standard") {
                        $scope.transferPictoUrl += "transferts-boat.svg";
                    } else if (vehicleTypeLowCase == "boat" && vehicleCategoryLowCase == "prestige") {
                        $scope.transferPictoUrl += "transferts-boat-premium.svg";
                    } else if (transferTypeLowCase == "private" && vehicleCategoryLowCase == "standard") {
                        $scope.transferPictoUrl += "transfert-private.svg";
                    } else if (transferTypeLowCase == "private" && vehicleCategoryLowCase == "prestige") {
                        $scope.transferPictoUrl += "transfert-private-premium.svg";
                    } else {
                        $scope.transferPictoUrl += "transfert.svg";
                    }
                    $scope.accommodation = window.$scope.bkgData.accommodations[0];
                    $scope.goSegmentDate = getLongFormattedDate($scope.transferInfo.segments[0].start, "-", false);
                    if ($scope.transferInfo.segments.length > 1)
                        $scope.returnSegmentDate = getLongFormattedDate($scope.transferInfo.segments[1].start, "-", false);

                    $scope.isTransferRecapLoading = false;
                }, 0);
            }

            $scope.$watch('transferinfo', function (newValue) {
                if (newValue) {
                    initransferInfo($scope.transferinfo);
                }
            });

            function getCurrentLanguage() {
                const culture = window.site.culture || null;

                if (!culture) return "fr-FR";

                switch (culture.toLowerCase()) {
                    case "it":
                        return "it-IT";
                    case "en":
                        return "en-US";
                    case "nl":
                        return "nl-BE";
                    default:
                        return "fr-FR";
                }
            }

            function getLongFormattedDate(isoDate, separator = ' - ', displayTime = true) {
                const date = new Date(isoDate);

                const day = date.toLocaleDateString(getCurrentLanguage(), { weekday: 'long' });
                const fullDate = date.toLocaleDateString(getCurrentLanguage(), { day: 'numeric', month: 'long', year: 'numeric' });
                const time = date.toLocaleTimeString(getCurrentLanguage(), { hour: '2-digit', minute: '2-digit', hour12: false });

                if (displayTime) {
                    return `${capitalize(day)} ${fullDate}${separator}${time}`;
                } else {
                    return `${capitalize(day)} ${fullDate}`;
                }
            }

            // Helper for capitalizing the first char
            function capitalize(str) {
                return str.charAt(0).toUpperCase() + str.slice(1);
            }


            $scope.drawerTransfertOpened = false;
            $scope.currentTransferDrawerInfo = null;

            $scope.openTransferDrawer = function (segmentIndex) {
                if ($scope.transferInfo && $scope.transferInfo.segments && $scope.transferInfo.segments.length > segmentIndex) {
                    $scope.drawerTransfertOpened = true;

                    // we select only the segment that we will display in the drawer
                    $scope.currentTransferDrawerInfo = {
                        ...$scope.transferInfo,
                        segments: [$scope.transferInfo.segments[segmentIndex]],
                        selectedSegmentIndex: segmentIndex
                    };
                }
            };

            $scope.toggleDrawerTransfert = function () {
                $scope.drawerTransfertOpened = !$scope.drawerTransfertOpened;
            };
        };
        return directive;
    }
]);